<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div
          class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-primary-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10 sm:tw--mt-1.5"
        >
          <key-icon class="tw-h-6 tw-w-6 tw-text-primary-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left tw-w-full">
          <h3 class="tw-text-xl tw-font-thin">Reset Password</h3>
          <base-form ref="form" v-model="isFormValid" class="tw-mt-3 tw-w-full">
            <base-text-field v-model="password" type="password" label="New Password" :rules="[rules.length]" class="tw-w-full" placeholder="Enter password" />
          </base-form>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="sendEmail" :loading="isLoading" :disabled="!isFormValid" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Confirm</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { KeyIcon } from "@/assets/svgs";

export default {
  components: {
    KeyIcon,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      password: "",
      isFormValid: true,
      rules: {
        length: (v) => v.length >= 8 || "Password must be at least 8 characters",
      },
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async sendEmail() {
      try {
        this.isLoading = true;
        this.$refs.form.validate();
        await this.$axios.post(`/businesses/${this.businessId}/users/${this.userId}/reset-password`, {
          password: this.password,
        });
        this.EventBus.$emit("GLOBAL_NOTIFY", {
          title: "Password reset successfully",
          message: "The password for this user was reset successfully",
        });
        this.hide();
        this.$refs.form.reset();
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Error resetting password",
          message: "We were not able to reset the password for this user. Please reload the page to try again.",
          error,
        });
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
